var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.roomState === 'upcoming')?_c('div',{staticClass:"div-100"},[_c('Teaser')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }